import { Component, Host, Prop, Watch, h } from '@stencil/core';

import type {
  IconTeaserImage,
  IconTeasers,
} from '../../helpers/utils/teaser-types';

@Component({
  tag: 'cms-icons-teaser',
  styleUrl: 'cms-icons-teaser.scss',
  shadow: true,
})
export class CmsIconsTeaser {
  private teaserData: IconTeasers[];

  /**
   * set the icon teaser data
   */
  @Prop() iconTeasers: IconTeasers | string;

  /**
   * set to highlight-variant
   */
  @Prop() variant: 'default' | 'highlight' = 'default';

  /**
   * set the accessible name
   */
  @Prop() accessibleName: string;

  @Watch('iconTeasers')
  private iconsWatcher(newValue: string | IconTeasers) {
    if (!newValue) return;
    this.teaserData =
      typeof newValue === 'string' ? JSON.parse(newValue) : newValue;
  }

  private renderImage(images: IconTeaserImage, altTitleText: string) {
    return (
      <picture class='image-wrapper'>
        <source type='image/webp' srcSet={`${images.bp120} 120w`} />
        <img
          loading='lazy'
          alt={altTitleText}
          title={altTitleText}
          class='icon-image'
          src={images.jpgDefault}
          width='120'
          height='80'
        />
      </picture>
    );
  }

  private renderTeaserHtml() {
    if (!this.teaserData?.length) return;
    return this.teaserData.map(
      ({
        teaserText,
        targetUrl,
        targetFrame,
        altTitleText,
        images,
        accessibleName,
      }) => {
        if (teaserText === '' && !images.bp120) {
          return '';
        }
        const itemStyle = {
          'icons-teaser': true,
          'no-link': targetUrl == null,
          'no-text': teaserText == null,
        };

        return (
          <li key={teaserText} class={itemStyle}>
            <a
              class={'teaser-link'}
              href={targetUrl}
              target={targetFrame}
              title={altTitleText}
              aria-label={accessibleName}
            >
              {images.bp120 ? (
                <div class='icons-image-wrapper'>
                  {this.renderImage(images, altTitleText)}
                </div>
              ) : null}
              {teaserText ? (
                <cms-link
                  href=''
                  class='text-container'
                  type='standalone-inverted'
                  linkTitle={teaserText}
                  content={teaserText}
                  size='sm'
                  tag='span'
                  style={{
                    '--cms-text-color':
                      'var(--cms-semanticColors-base-strong-text)',
                  }}
                />
              ) : null}
            </a>
          </li>
        );
      },
    );
  }

  connectedCallback() {
    if (!this.iconTeasers) return;

    this.iconsWatcher(this.iconTeasers);
  }

  render() {
    const containerStyles = {
      'has-bg': true,
      [this.variant]: true,
    };
    return (
      <Host class={containerStyles}>
        <ul class={'host-inner'} aria-label={this.accessibleName}>
          {this.renderTeaserHtml()}
        </ul>
      </Host>
    );
  }
}
